// mapping table column name to a more readable label
export const tableLabels = {
  credit_card: {
    number: 'Card Number',
  },
  criteria_set: {
    criteria_set: 'Criteria ID',
    join: 'Join ID',
  },
  document: {
    full_name: 'Concerned Person',
    issuing_org: 'Issuing Organisation',
    org_indicator: 'Organisation Indicator',
    file: 'Document',
  },
  organisation: {
    city_location: 'City',
  },
  contract: {
    document_link: 'Document',
  },
  person: {
    date_of_birth: 'Birth Date',
    date_of_death: 'Death Date',
    birth_country: 'Country',
    marit_st_last_change: 'Marital Status Last Change',
  },

  vaccination_history: {
    org: 'Organisation',
  },
  contract_item: {
    financial_category: 'Financial Account',
    subject: 'Item Ref. ID',
  },
  user_payment: {
    payment_date: 'Payment YY Date',
    payment_coverage: 'Payment XX Coverage',
  },
  income: {
    period: 'month',
    amount_sc: 'Space Amount',
    sp_currency: 'Space Currency',
    partner_org_ind: 'Partner Org. Ind.',
    partner: 'Transaction partner',
    bpos_org_indicator: 'Bpos Org. Indicator',
  },
  asset_shift: {
    period: 'month',
    amount_sc: 'Space Amount',
    sp_currency: 'Space Currency',
    partner_org_ind: 'Partner Org. Ind.',
    partner: 'Transaction partner',
    bpos_org_indicator: 'Bpos Org. Indicator',
    position_link: 'Acc. Position',
    offset_position_link: 'Offset Acc. Pos.',
  },
  consumption: {
    amount_sc: 'Space Amount',
    sp_currency: 'Space Currency',
    partner_org_ind: 'Partner Org. Ind.',
    partner: 'Transaction partner',
    bpos_org_indicator: 'Bpos Org. Indicator',
  },
  auto_mobile: {
    type_model_spec: 'Type (model spec.)',
    vehicle_id_no: 'Vehicle Identification Number',
  },
  real_estate: {
    hab_surface: 'Habitable surface',
    total_land: 'Total area of property',
    tot_land_measure: 'Total land measurement',
    hab_surf_measure: 'Habitable surface measurement',
    ownership_reason: 'Reason of ownership',
    reg_number: 'Register number',
  },
  task_monitor: {
    task_id: 'Task ID',
    task_name: 'Task Name',
    status: 'Status',
    start_time: 'Start Time',
    end_time: 'End Time',
    runtime: 'Runtime (seconds)',
    error_message: 'Error Message',
  },
};

// const transaction_item = ['month'];

const transaction_item = [
  'account_category',
  'amount',
  'amount_sc',
  'sp_currency',
  'currency',
  'offset_account',
  'dc_indicator',
  'financial_account',
  'line',
  'measurement_unit',
  'position_link',
  'quantity',
  'offset_account_category',
  'original_doc_no',
  'reverse_doc_no',
  'reversal',
  'reversed',
  'bpos_org_indicator',
];

// extending tables with more columns
export const gExtraColumns = {
  bank_account: ['is_active', 'organisation'],
  credit_card: ['person', 'issuing_org', 'license_org'],
  criteria_set: ['criteria_set', 'criteria_set_description', 'join_description'],
  document: ['full_name'],
  expenses: [...transaction_item, 'person'],
  consumption: [...transaction_item, 'person'],
  income: [...transaction_item, 'person'],
  asset_shift: [...transaction_item, 'offset_position_link', 'person'],
  join_builder: ['space'],
  person: ['last_name'],
  organisation: ['city_location', 'parent_org', 'org_motivation'],
  vocational_training: ['organisation'],
  transaction: ['contract', 'contract_item'],
  space_member: ['request_date'],
  contract: ['renewal_period', 'renewal_period_unit'],
  organisation: ['org_country', 'state'],
  work_experience: ['industry'],
  work_absence: ['industry'],
};

// removing columns from tables
export const gRemoveColumns = {
  credit_card: ['_person', '_issuing_org', '_license_org', '_card_type', '_card_no'],
  time_dependent_name: [
    'person',
    // 'space_detail', 
    // 'reason_detail', 
    // 'person_id'
  ],
  document: [
    'content_type',
    'file_blob',
    'filename',
    'concerned_person_id',
    'mail',
    'size',
  ],
  join_builder: ['space_name'],
  relation: ['relation'],
  organisation: [
    'modified',
    'org_password',
    'organisation_logo',
    // 'approved',
    'approval',
    'public_resp_area',
    'main_space',
    'active',
    'register_doc',
    'register_doc_type',
  ],
  vocational_training: ['school'],
  person: ['ethnic_group', 'person_picture'],
  address: ['address_type_identifier', 'street_direction', 'address_type'],
  contract: ['document'],
  space_member: ['is_space_admin', 'is_approved', 'is_disapproved', 'admin_change_request_token'],
  contract_item: ['expense_category'],
  user_payment: ['user'],
  // income: ['offset_financial_account'],
  // consumption: ['offset_financial_account'],
};

// modify column name can point to a modified data. we therefore
// points this modified column to the right ones
// e.g. original_column = _modified_column
export const gModifyIds = {
  address: {
    country: '_country',
    state: '_state',
    city: '_city',
    street_direction: '_street_direction',
    address_type: '_address_type',
  },
  bank_account: {
    valid_from: '_valid_from',
    valid_to: '_valid_to',
    BIC: '_BIC',
    access_type: '_access_type',
    account_type: '_account_type',
    account_ref: '_account_ref',
  },
  citizenship: {
    citizen: '_citizen',
    nationality: '_nationality',
    valid_from: '_valid_from',
    valid_to: '_valid_to',
  },
  contact: {
    person: '_person',
    address: '_address',
    contact_type: '_contact_type',
    active: '_active',
  },
  credit_card: {
    person: '_person',
    issuing_org: '_issuing_org',
    license_org: '_license_org',
    number: 'card_no',
    card_type: '_card_type',
    account_ref: '_account_ref',
  },
  document: {
    document_type: 'doc_type',
    city: '_city',
    language: 'lang',
    issuing_org: '_issuing_org',
    issuing_date: '_issuing_date',
  },
  join_builder: {
    space_name: 'space',
    space: 'space',
  },

  organisation: {
    legal_form: '_legal_form',
    public: '_public',
    foundation: '_foundation',
    liquidation: '_liquidation',
    // country: "_country",
    state: '_state',
    active: '_active',
    organisation_type: '_organisation_type',
    city_location: '_city_location',
    register_institute: '_register_institute',
    revenue_currency: '_revenue_currency',
    org_country: '_org_country',
    industry: '_industry',
    no_of_employees: '_no_of_employees',
    revenue_approx: '_revenue_approx',
    legal_personality: '_legal_personality',
    non_profit: '_non_profit',
    org_motivation: '_org_motivation',
    parent_org: '_parent_org',
    transfer_date: '_transfer_date',
  },

  person: {
    birth_country: '_birth_country',
    ethnic_group: '_ethnic_group',
    title: '_title',
    height: '_height',
    eye_color: '_eye_color',
    religion: '_religion',
    sex: '_sex',
    marital_status: '_marital_status',
    marit_st_last_change: '_marit_st_last_change',
    height_unit: '_height_unit',
    date_of_birth: '_date_of_birth',
    date_of_death: '_date_of_death',
  },
  relation: {
    person: '_person',
    relation_to: '_relation_to',
    relation_part: '_relation_part',
    valid_from: '_valid_from',
    valid_to: '_valid_to',
  },
  residence: {
    resident: '_resident',
    address: '_address',
    valid_from: '_valid_from',
    valid_to: '_valid_to',
    principal_indicator: '_principal_indicator',
  },
  vaccination_history: {
    person: '_person_id',
    org: '_org_id',
    vaccination_date: '_vaccination_date',
  },
  companion_animal: {
    animal: '_animal',
    date_of_birth: '_date_of_birth',
    date_of_death: '_date_of_death',
    owner: '_owner',
  },
 
  user_payment: {
    payment_date: '_payment_date',
    payment_coverage: '_payment_coverage',
  },
  real_estate: {
    reg_number: '_reg_number',
  },
  income: {
    transaction: 'transaction',
    // partner_org_ind: '_partner_org_ind',
  },
  consumption: {
    transaction: 'transaction',
    // partner_org_ind: '_partner_org_ind',
  },
  asset_shift: {
    transaction: 'transaction',
  },
};

export const setDefaultColumn = {
  person: [
    'title',
    'last_name',
    'first_name',
    'other_names',
    'date_of_birth',
    'birth_place',
    'birth_country',
    'sex',
    'eye_color',
    'marital_status',
    'marit_st_last_change',
    'height',
    'height_unit',
    'religion',
    'date_of_death',
    'space',
  ],
  person_group: ['description', 'space'],
  companion_animal: [
    'animal',
    'name',
    'date_of_birth',
    'date_of_death',
    'owner',
    'space',
  ],
  relation: [
    'person_id',
    'relation_part',
    'relation_to',
    'valid_from',
    'valid_to',
    'space',
  ],
  contract: [
    'data_area',
    'org_indicator',
    'contractor',
    'description',
    'contract',
    'customer',
    'person_id',
    'person_is',
    'continuous',
    'start_date',
    'run_time',
    'run_time_unit',
    'end_date',
    'auto_renewal',
    'renewal_period',
    'renewal_period_unit',
    'notice_period',
    'notice_period_unit',
    'document_link',
    'space',
  ],
  contract_item: [
    'contract',
    'item',
    'fix_or_var',
    'financial_category',
    'account_category',
    'item_description',
    'fix_amount',
    'fix_period_unit',
    'currency',
    'var_service_rate',
    'var_service_unit',
    'subject',
    'item_reference',
    'counter_reading_b',
    'counter_reading_e',
    'space',
  ],
  organisation: [
    'name',
    'legal_form',
    'industry',
    'org_country',
    'state',
    'city_location',
    'foundation',
    'liquidation',
    'org_motivation',
    'public',
    'non_profit',
    'revenue_approx',
    'revenue_currency',
    'register_institute',
    'register_no',
    'legal_personality',
    'parent_org',
    'no_of_employees',
    'website',
  ],
  disease_history: ['person', 'disease', 'valid_from', 'valid_to', 'space'],
  vaccination_history: [
    'person',
    'vaccination_date',
    'org',
    'trade_name',
    'batch_no',
    'space',
  ],
  address: [
    'country',
    'post_area',
    'city',
    'street_name',
    'street_no',
    'street_no_suffix',
    'state',
    'local_muncipality',
    'building_name',
    'space',
  ],
  residence: [
    'address',
    'resident',
    'valid_from',
    'valid_to',
    'principal_indicator',
    'space',
  ],
  contact: [
    'active',
    'person',
    'contact_type',
    'email',
    'tel_country_code',
    'tel_area_code',
    'tel_number',
    'address',
    'website',
    'space',
  ],
  citizenship: ['citizen', 'nationality', 'valid_from', 'valid_to', 'space'],
  work_experience: [
    'person',
    'organisation',
    'valid_from',
    'valid_to',
    'title_description',
    'profession',
    'industry',
    'space',
  ],
  membership: ['person', 'organisation', 'valid_from', 'valid_to', 'space'],
  bank_account: [
    'account_type',
    'account_no',
    'BIC',
    'valid_from',
    'valid_to',
    'currency',
    'access_type',
    'organisation',
    'account_ref',
    'IBAN',
    'is_active',
    'space',
  ],
  credit_card: [
    'person',
    'license_org',
    'card_type',
    'number',
    'valid_thru',
    'issuing_org',
    'account_ref',
    'cvc',
    'space',
  ],
  income: [
    'year',
    'period',
    'date',
    'person',
    'amount',
    'currency',
    'amount_sc',
    'sp_currency',
    'financial_account',
    'offset_account',
    'description',
    'contract',
    'reversed',
    'reverse_doc_no',
    'reversal',
    'original_doc_no',
    'quantity',
    'measurement_unit',
    'bpos_org_indicator',
    'account_category',
    'offset_account_category',
    'partner',
    'partner_org_ind',
    // 'transaction',
    'line',
    'position_link',
    'dc_indicator',
    'space',
  ],
  asset_shift: [
    'year',
    'period',
    'date',
    'person',
    'amount',
    'currency',
    'amount_sc',
    'sp_currency',
    'financial_account',
    'offset_account',
    'description',
    'contract',
    'reversed',
    'reverse_doc_no',
    'reversal',
    'original_doc_no',
    'quantity',
    'measurement_unit',
    'bpos_org_indicator',
    'account_category',
    'offset_account_category',
    'partner',
    'partner_org_ind',
    // 'transaction',
    'line',
    'position_link',
    'offset_position_link',
    'dc_indicator',
    'space',
  ],
  consumption: [
    'year',
    'period',
    'date',
    'person',
    'amount',
    'currency',
    'amount_sc',
    'sp_currency',
    'financial_account',
    'offset_account',
    'description',
    'contract',
    'reversed',
    'reverse_doc_no',
    'reversal',
    'original_doc_no',
    'quantity',
    'measurement_unit',
    'bpos_org_indicator',
    'account_category',
    'offset_account_category',
    'partner',
    'partner_org_ind',
    'line',
    'position_link',
    'dc_indicator',
    'space',
  ],

  attachment_rule: [
    'description',
    'data_area',
    'document_type',
    'person_id',
    'organisation',
    'language',
    'reference_year',
    'reference_month',
    'space',
  ],
  further_training: [
    'person',
    'category',
    'valid_from',
    'valid_to',
    'organisation',
    'graduation_goal',
    'school_subject',
    'last_class',
    'degree_achieval',
    'final_grade',
    'study_subject',
    'vocschool_subject',
    'profession',
    'industry',
    'further_training',
    'language',
    'language_verbal',
    'language_literacy',
    'space',
  ],
  academic_studies: [
    'person',
    'category',
    'valid_from',
    'valid_to',
    'organisation',
    'graduation_goal',
    'school_subject',
    'last_class',
    'degree_achieval',
    'final_grade',
    'study_subject',
    'vocschool_subject',
    'profession',
    'industry',
    'further_training',
    'language',
    'language_verbal',
    'language_literacy',
    'space',
  ],
  general_education: [
    'person',
    'category',
    'valid_from',
    'valid_to',
    'organisation',
    'graduation_goal',
    'school_subject',
    'last_class',
    'degree_achieval',
    'final_grade',
    'study_subject',
    'vocschool_subject',
    'profession',
    'industry',
    'further_training',
    'language',
    'language_verbal',
    'language_literacy',
    'space',
  ],
  languages: [
    'person',
    'category',
    'valid_from',
    'valid_to',
    'organisation',
    'graduation_goal',
    'school_subject',
    'last_class',
    'degree_achieval',
    'final_grade',
    'study_subject',
    'vocschool_subject',
    'profession',
    'industry',
    'further_training',
    'language',
    'language_verbal',
    'language_literacy',
    'space',
  ],
  pre_school: [
    'person',
    'category',
    'valid_from',
    'valid_to',
    'organisation',
    'graduation_goal',
    'school_subject',
    'last_class',
    'degree_achieval',
    'final_grade',
    'study_subject',
    'vocschool_subject',
    'profession',
    'industry',
    'further_training',
    'language',
    'language_verbal',
    'language_literacy',
    'space',
  ],
  vacational_school: [
    'person',
    'category',
    'valid_from',
    'valid_to',
    'organisation',
    'graduation_goal',
    'school_subject',
    'last_class',
    'degree_achieval',
    'final_grade',
    'study_subject',
    'vocschool_subject',
    'profession',
    'industry',
    'further_training',
    'language',
    'language_verbal',
    'language_literacy',
    'space',
  ],
  vocational_training: [
    'person',
    'category',
    'valid_from',
    'valid_to',
    'organisation',
    'graduation_goal',
    'school_subject',
    'last_class',
    'degree_achieval',
    'final_grade',
    'study_subject',
    'vocschool_subject',
    'profession',
    'industry',
    'further_training',
    'language',
    'language_verbal',
    'language_literacy',
    'space',
  ],
  auto_mobile: [
    'means_of_transport_category',
    'auto_brand',
    'model_series',
    'type_model_spec',
    'construction_year',
    'color',
    'energy_source',
    'max_speed',
    'measurement_unit',
    'power',
    'cubic_capacity',
    'no_of_doors',
    'no_of_seats',
    'vehicle_id_no',
    'initial_reg_date',
    'space',
  ],
  auto_registration: [
    'auto_mobile',
    'person',
    'registration_org',
    'valid_from',
    'valid_to',
    'licence_plate',
    'document',
    'space',
  ],
  work_absence: [
    'person',
    'organisation',
    'industry',
    'valid_from',
    'valid_to',
    'absence_type',
    'comment',
    'space',
  ],
  travel: [
    'description',
    'type_of_travel',
    'person',
    'main_mot',
    'address',
    'country',
    'valid_from',
    'valid_to',
    'space',
  ],
  real_estate: [
    'realestate_type',
    'hab_surface',
    'hab_surf_measure',
    'total_land',
    'tot_land_measure',
    'associated_share',
    'construction_year',
    'cadastral_register',
    'page',
    'reg_number',
    'address',
    'ownership_reason',
    'contract',
    'valid_from',
    'valid_to',
    'space',
  ],
  task_monitor: [
    'task_id',
    'task_name', 
    'status',
    'start_time',
    'end_time',
    'runtime',
    'error_message',
  ],
  time_dependent_name: [
    'person_id',
    'reason'
  ]
};
